import type {
	AbstractLeadCalculatorRequest,
	AbstractLeadCalculatorResponse,
} from "@component/assets/AbstractLeadForm/types";
import type { Debtor } from "@component/PersonalLoan/LeadForm/types";
import type { FormIncomeSimpleData } from "@shared/ui";

export type Variant = "erste";

export type EligibleForBabyLoan =
	| ""
	| "NO_NOT_CREDITABLE"
	| "YES_FULL_AMOUNT"
	| "YES_BUT_LESS_THAN_FULL"
	| "NO_OTHER_PRODUCT_RECOMMENDED"
	| "NO_OTHER_PRODUCT_RECOMMENDED_WITH_LESS_AMOUNT";

export enum ErrorCode {
	AGE = 0,
	MARRIED = 1,
	CHILD = 2,
	ADDRESS = 3,
	NAV = 4,
	KHR = 5,
	SOC = 6,
	NO_INCOME = 7,
	DAYSSOCINHUN = 8,
}

export interface BabyLoanRequest {
	extendBabyLoanWith: ("CSOK" | "MORTGAGE" | "PERSONAL_LOAN")[];
	creditLimitSumValue: number;
	currentLoansMonthlyInstallment: number;
	loanAmount: number;
	birthDate: string;
	inKHR: boolean;
	married: boolean;
	hasBothOfTheCoupleHunAddress?: boolean;
	hasEitherOfCoupleNavDebt?: boolean;
	isLast180daysSocInHun?: boolean;
	hasEitherOfCoupleSocialInsurance?: string;
	incomeList: FormIncomeSimpleData[];
	wantsWithOnlineService: boolean;
	productName: string;
}

export interface BabyLoanResponse {
	totalIncome: number;
	singleIncome: number;
	hasAcceptableIncome: boolean;

	eligibleForBabyLoan: EligibleForBabyLoan;
	eligibleForBabyLoanValue: number;

	monthlyInstallment: number;
	maxInstallment: number;
	maxLoanAmount: number;
	freelyUsableMonthlyInstallment: number;
	maxFreelyUsableInstallment: number;
	maxFreelyUsableLoanAmount: number;
	realInstallment: number;
	freelyUsableRealInstallment: number;
	realLoanAmount: number;
	freelyUsableRealLoanAmount: number;
	errors: ErrorCode[];
}

export interface IncomeData {
	totalIncome: number;
	hasAcceptableIncome: boolean;
	singleIncome: number;
}

export interface BabyLoanLeadCalcRequest extends AbstractLeadCalculatorRequest {
	debtor: Debtor;
	incomeList: FormIncomeSimpleData[];
	hasBothOfTheCoupleHunAddress: boolean;
	hasEitherOfCoupleNavDebt: boolean;
	loanAmount: number;
	inKHR: boolean;
	married: boolean;
	birthDate: string;
	hasEitherOfCoupleSocialInsurance: string;
	isLast180daysSocInHun: boolean;
	currentLoansMonthlyInstallment: number;
	creditLimitSumValue: number;
	productRequisitionTime: string; // ProductRequisitionTime;
	otherRequiredProducts?: string;
}

export interface BabyLoanLeadCalcResponse extends AbstractLeadCalculatorResponse {
	maxInstallment: number;
	maxLoanAmount: number;
	monthlyInstallment: number;
	singleIncome: number;
	eligibleForBabyLoan: EligibleForBabyLoan;
	ko0: boolean;
	ko1: boolean;
	ko2: boolean;
	ko3: boolean;
	ko4: boolean;
	ko5: boolean;
	ko6: boolean;
	ko7: boolean;
	ko8: boolean;
	extendBabyLoanWithCSOK: boolean;
	extendBabyLoanWithMortgage: boolean;
	extendBabyLoanWithPersonalLoan: boolean;
	freelyUsableRealInstallment: number;
	maxFreelyUsableInstallment: number;
	freelyUsableRealLoanAmount: number;
	maxFreelyUsableLoanAmount: number;
	realInstallment: number;
	realLoanAmount: number;
	csokAmount: number;
	vatRefund: number;
	renovationAid: number;
	feeDiscount: number;
	canGetMortgage: boolean;
	relatedMortgageLoanAmount: number;

	// TODO: Lehet nem kell
	totalIncome: number;
	hasAcceptableIncome: boolean;
	freelyUsableMonthlyInstallment: number;
	eligibleForBabyLoanValue: number;
	hasKo: boolean;
}
